import { useIntl } from 'react-intl';

import { Summary } from '@/components/Summary';
import {
  getTranslatedPaymentMethodName,
  isTokenizablePaymentMethod,
} from '@/lib/payment/helpers';
import { paymentMessages } from '@/messages/payment';
import type { CheckoutState } from '@/states/checkout';

type PaymentSummaryProps = Pick<CheckoutState, 'paymentMethod'> & {
  onEdit: () => void;
};

export const PaymentSummary = ({
  onEdit,
  paymentMethod,
}: PaymentSummaryProps) => {
  const { formatMessage } = useIntl();

  if (!paymentMethod?.type) {
    return null;
  }

  return (
    <Summary data-test-id='PaymentSummary' name='payment'>
      <Summary.Header data-test-id='PaymentSummaryHeader' onClick={onEdit}>
        {formatMessage(paymentMessages.paymentMethod)}
      </Summary.Header>
      <Summary.Section data-test-id='PaymentSummarySection'>
        <Summary.Entry data-test-id='PaymentSummaryEntry'>
          <Summary.Line data-test-id='PaymentSummaryLineBold' isBold>
            {formatMessage(getTranslatedPaymentMethodName(paymentMethod.type))}
          </Summary.Line>

          {isTokenizablePaymentMethod(paymentMethod.type) &&
            paymentMethod.extraInfo && (
              <>
                <Summary.Line data-test-id='PaymentSummaryHolderName'>
                  {paymentMethod.extraInfo?.holderName}
                </Summary.Line>
                <Summary.Line data-test-id='PaymentSummaryLastDigits'>
                  **** **** **** {paymentMethod.extraInfo?.last4}
                </Summary.Line>
                <Summary.Line data-test-id='PaymentSummaryExpiryDate'>
                  {formatMessage(paymentMessages.expiryDate)}{' '}
                  {paymentMethod.extraInfo?.expiryDate}
                </Summary.Line>
              </>
            )}
        </Summary.Entry>
      </Summary.Section>
    </Summary>
  );
};
